var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccountPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22056 3.98089C6.07018 3.61762 5.67371 3.42427 5.29482 3.52778L3.57615 3.99651C3.23632 4.09026 3 4.39884 3 4.75039C3 9.5822 6.9178 13.5 11.7496 13.5C12.1012 13.5 12.4097 13.2637 12.5035 12.9239L12.9722 11.2052C13.0757 10.8263 12.8824 10.4298 12.5191 10.2794L10.6442 9.49822C10.3258 9.36542 9.95673 9.45721 9.73994 9.72478L8.95091 10.6876C7.57597 10.0373 6.46274 8.92403 5.81238 7.54909L6.77522 6.76202C7.04279 6.54328 7.13458 6.1761 7.00178 5.85776L6.22056 3.98284V3.98089Z",
    fill: "#6D738D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccountPhone);
export default __webpack_public_path__ + "static/media/my_account_phone.a915abe8c692102fc7a2558a2634c857.svg";
export { ForwardRef as ReactComponent };